import { render, staticRenderFns } from "./GenericSelector.vue?vue&type=template&id=50e81d07"
import script from "./GenericSelector.vue?vue&type=script&lang=js"
export * from "./GenericSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports